import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import MandateReport from "./MandateReport";
import DigioMandate from "./DigioMandate";
import SIPTransactionReport from "./SIPTransactionReport";
import RecurringDashboardReportQue from "./RecurringDashboardReportQue";
import BSEReconciliation from "./BSEReconciliation";
 
export default function MutualFunds(props) {
  const [activeTab, setActiveTab] = useState("Report");
  const [reloadKey, setReloadKey] = useState(0);
 
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    localStorage.setItem("tabName", tabName);
 
    // Reload only for specific tabs
    if (tabName !== "Digio Mandate" && tabName !== "SIP Transaction Report") {
      setReloadKey((prev) => prev + 1); // change key -> forces reload
    }
  };
 
  useEffect(() => {
    const savedTab = localStorage.getItem("tabName");
    if (savedTab) {
      setActiveTab(savedTab);
    }
  }, []);
 
  const renderActiveTab = () => {
    switch (activeTab) {
      case "Report":
        return <MandateReport key={reloadKey} />;
      case "Digio Mandate":
        return <DigioMandate />;
      case "SIP Transaction Report":
        return <SIPTransactionReport />;
      case "Recurring Dashboard Report Que":
        return <RecurringDashboardReportQue key={reloadKey} />;
      case "BSE Reconciliation":
        return <BSEReconciliation key={reloadKey} />;
      default:
        return null;
    }
  };
 
  return (
    <div>
      <Header title={props.title} portal="RM" />
      <SingleSignOnSideBar />
      <main id="main-content" className="mutualfunds">
        <div className="tab-content card-box" id="mainTabContent">
          <div className="secondary-tabs">
            <div className="card-tab-list">
              <ul className="nav page-tabs" id="mainTab" role="tablist">
                {["Report", "Digio Mandate", "SIP Transaction Report", "Recurring Dashboard Report Que", "BSE Reconciliation"]
                  .map((tab) => (
                    <li className="nav-item" key={tab} role="presentation">
                      <button
                        className={`nav-link ${activeTab === tab ? "active" : ""}`}
                        onClick={() => handleTabClick(tab)}
                        type="button"
                      >
                        {tab}
                      </button>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="card-tab-details">
              <div className="tab-content dashboard-tab-content">
                {renderActiveTab()}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}




















// import React from "react";
// import Header from "../../Components/Header";
// import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
// import MandateReport from "./MandateReport";
// import DigioMandate from "./DigioMandate";
// import SIPTransactionReport from "./SIPTransactionReport";
// import RecurringDashboardReportQue from "./RecurringDashboardReportQue";
// import BSEReconciliation from "./BSEReconciliation";

// export default function MutualFunds(props) {
//   return (
//     <div>
//       <Header title={props.title} portal={"RM"} />
//       <SingleSignOnSideBar />
//       <main id="main-content" className="mutualfunds">
//         <div className="tab-content card-box" id="mainTabContent">
//           {/* <div>
//             <h2>Mutual Funds Details</h2>
//           </div> */}
//           <div
//             className="tab-pane fade show active"
//             id="team"
//             role="tabpanel"
//             aria-labelledby="team-tab"
//           >
//             <div className="secondary-tabs">
//               <div className="card-tab-list">
//                 <ul className="nav page-tabs" id="mainTab" role="tablist">
//                   <li className="nav-item" role="presentation">
//                     <button
//                       className="nav-link active"
//                       id="branch-tab"
//                       data-toggle="tab"
//                       data-target="#branch"
//                       type="button"
//                       role="tab"
//                       aria-controls="branch"
//                       aria-selected="true"
//                     >
//                       Report
//                     </button>
//                   </li>
//                   <li className="nav-item" role="presentation">
//                     <button
//                       className="nav-link"
//                       id="digio-tab"
//                       data-toggle="tab"
//                       data-target="#digio"
//                       type="button"
//                       role="tab"
//                       aria-controls="digio"
//                       aria-selected="false"
//                     >
//                       Digio Mandate
//                     </button>
//                   </li>
//                   <li className="nav-item" role="presentation">
//                     <button
//                       className="nav-link"
//                       id="sip-tab"
//                       data-toggle="tab"
//                       data-target="#sip"
//                       type="button"
//                       role="tab"
//                       aria-controls="sip"
//                       aria-selected="false"
//                     >
//                       SIP Transaction Report
//                     </button>
//                   </li>
//                   <li className="nav-item" role="presentation">
//                     <button
//                       className="nav-link"
//                       id="rdr-tab"
//                       data-toggle="tab"
//                       data-target="#rdr"
//                       type="button"
//                       role="tab"
//                       aria-controls="rdr"
//                       aria-selected="false"
//                     >
//                       Recurring Dashboard Report Que
//                     </button>
//                   </li>
//                   <li className="nav-item" role="presentation">
//                     <button
//                       className="nav-link"
//                       id="bse-tab"
//                       data-toggle="tab"
//                       data-target="#bse"
//                       type="button"
//                       role="tab"
//                       aria-controls="bse"
//                       aria-selected="false"
//                     >
//                       BSE Reconciliation
//                     </button>
//                   </li>
//                 </ul>
//               </div>
//               <div className="card-tab-details">
//                 <div
//                   className="tab-content dashboard-tab-content"
//                   id="nav-tabContent"
//                 >
//                   <div
//                     className="tab-pane fade show active"
//                     id="branch"
//                     role="tabpanel"
//                     aria-labelledby="nav-branch-tab"
//                   >
//                     <MandateReport />
//                   </div>
//                   <div
//                     className="tab-pane fade show"
//                     id="digio"
//                     role="tabpanel"
//                     aria-labelledby="nav-digio-tab"
//                   >
//                     <DigioMandate />
//                   </div>
//                   <div
//                     className="tab-pane fade show"
//                     id="sip"
//                     role="tabpanel"
//                     aria-labelledby="nav-sip-tab"
//                   >
//                     <SIPTransactionReport />
//                   </div>
//                   <div
//                     className="tab-pane fade show"
//                     id="rdr"
//                     role="tabpanel"
//                     aria-labelledby="nav-rdr-tab"
//                   >
//                     <RecurringDashboardReportQue />
//                   </div>
//                    <div
//                     className="tab-pane fade show"
//                     id="bse"
//                     role="tabpanel"
//                     aria-labelledby="nav-bse-tab"
//                   >
//                     <BSEReconciliation />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// }
